import React from 'react'
import { Drawer } from 'antd'
import { useDispatch } from 'react-redux'
import { questionActions } from '../../../../../store/slices/question.slice'
import CompareWithLmsFormContainer from './CompareWithLmsFormContainer'

const CompareWithLmsDrawer = () => {
    const dispatch = useDispatch()

    const handleClose = () => dispatch(questionActions.setShowCompareWithLmsDrawer(false))

    return (
        <Drawer title='Compare With LMS' autoFocus onClose={handleClose} open width={720} destroyOnClose>
            <CompareWithLmsFormContainer onSuccess={handleClose} />
        </Drawer>
    )
}

export default CompareWithLmsDrawer
